import { useQuery } from '@tanstack/react-query';

import { getGroupedReleaseNotesApi, getLatestReleaseNoteApi } from 'api/releaseNotes';
import {
  GetGroupedReleaseNotesResponseDTO,
  LatestReleaseNoteDto,
} from 'declarations/dto/releaseNotes';
import { RequestQueryKeysE, RequestStaleTimeE } from 'declarations/enums/react-query';
import { ApiErrorI } from 'declarations/interfaces/errors';

export const useFetchGroupedReleaseNotes = () =>
  useQuery<GetGroupedReleaseNotesResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.FetchGroupedReleaseNotes],
    () => getGroupedReleaseNotesApi(),
    { staleTime: RequestStaleTimeE.GroupedReleaseNotes }
  );

export const useFetchLatestReleaseNote = () =>
  useQuery<LatestReleaseNoteDto, ApiErrorI>(
    [RequestQueryKeysE.FetchLatestReleaseNote],
    () => getLatestReleaseNoteApi(),
    { staleTime: RequestStaleTimeE.GroupedReleaseNotes }
  );
